import {AfterViewInit, Component, Input, OnInit} from "@angular/core";
import {C1Bill, C1BillResult} from "../../shipper";
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {Observable} from "rxjs";
import {C1BillResultItem} from "./c1.bill.result.item";
import {
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective, NgbAccordionHeader, NgbAccordionItem
} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'c1-bill-result-view',
    standalone: true,
    styleUrls: ['c1.css'],
    imports: [
        NgIf,
        NgForOf,
        AsyncPipe,
        C1BillResultItem,
        NgbAccordionBody,
        NgbAccordionButton,
        NgbAccordionCollapse,
        NgbAccordionDirective,
        NgbAccordionHeader,
        NgbAccordionItem,
    ],
    template:`
        <div *ngIf="billResult | async as results">
            
            
            <div ngbAccordion #accordion="ngbAccordion" [closeOthers]="true" [destroyOnHide]="false">
                
                <div ngbAccordionItem="{{result.id}}" *ngFor="let result of results" [collapsed]="true">
                    
                    <h2 ngbAccordionHeader>
                        <button ngbAccordionButton>
                            <div class="input-group">
                                <div>
                                    <i class="fa fa-arrow-circle-right me-2" aria-hidden="true"></i>
                                    
                                    <span *ngIf="result.bills.length > 0 && isOcean(result.bills)">
                                        <span>Master Bill: {{mb(result.bills)}} {{coalesceBill(result.bills)}}</span>
                                        <span class="badge badge-pill badge-bill-type align-items-lg-end">
                                            <span class="badge bg-secondary">{{ billType(result.bills[0]?.billType) }}</span>
                                        </span>
                                    </span>
                                    
                                    
                                    <span *ngIf="result.bills.length > 0 && isAir(result.bills)">
                                        Airbill: {{result.bills[0]?.airbillNumber}}
                                        <span *ngIf="result.bills[0]?.flightNumber != null"> | Flight: {{ result.bills[0]?.flightNumber}}</span> {{coalesceBill(result.bills)}}
                                    </span>
                                
                                </div>
                            </div>
                        </button>
                    </h2>
                    
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
								<bill-result-item [result]="result"></bill-result-item>
                            </ng-template>
                        </div>
                    </div>
                
                </div>
            </div>
            
        </div>
    `,
    styles:[`
        .accordion {
            --bs-accordion-active-bg: #32363d;
           /* --bs-accordion-active-color: #41464d; */
        }
        
        
        .accordion-button:focus {
            box-shadow: none;
        }
    
    `]
})
export class C1BillResultView implements OnInit, AfterViewInit{
    
    @Input()
    billResult!:Observable<Array<C1BillResult>>;

    @Input()
    collapseAll: boolean = true;
    
    private billTypes:Map<string,string> = new Map([
        ["0","Regular"],
        ["M","Master"],
        ["H","House"],
        ["F","FROB"]
    ]);
    
    
    constructor() {}
    
    ngAfterViewInit(): void {}

    
    
    ngOnInit(): void {
        //this.collapseAll = this.results?.length > 1;
    }
    
    
    /**
     *
     * @param bills
     */
    public coalesceBill(bills:Array<C1Bill>){
        
        let str:any[] = [];
        
        bills.forEach((bill) => {
            
            if(bill.billType == 'H'){
                str = ["|", "House:",bill.houseBillScac+bill.houseBillNumber];
            }
            
            if(bill.inbondNumber){
                str =  ["|","Inbond:",bill.inbondNumber];
            }
            
            if(bill.houseAirbillNumber){
                str =  ["|", "House:", bill.houseAirbillNumber];
            }
        });
        
        return str.join(" ");
    }
    
    
    /**
     *
     * @param bills
     */
    public mb(bills:Array<C1Bill>){
        return bills[0].masterBillScac + bills[0].masterBillNumber;
    }
    
    
    /**
     *
     * @param bills
     */
    public isAir(bills:Array<C1Bill>):boolean{
        return bills[0].billType == null;
    }
    
    
    /**
     *
     * @param bills
     */
    public isOcean(bills:Array<C1Bill>){
        return bills[0].billType != null;
    }
    
    
    /**
     *
     * @param type
     */
    public billType(type:string|undefined){
        
        if(!type){return null;}
        
        if(this.billTypes.has(type)){
            return this.billTypes.get(type);
        }
        
        return type;
    }

}
